const required: () => FormRule = () => value => {
  return (typeof value !== 'undefined' && value !== null) || 'This field is required.';
};

const maxLength: (max: number) => FormRule = max => value =>
  !value || value.length <= max || `This field must be ${max} characters or less.`;

const email: () => FormRule = () => value =>
  !value || /.+@[^.]+\..+/.test(value) || 'This field must be a valid email format (e.g. "bob@example.org").';

const phone: (opts?: { withExt?: boolean }) => FormRule = opts => value => {
  const phoneRe = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.\-]?\d{3}[\s.\-]?\d{4}$/;
  const phoneWithExtRe = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.\-]?\d{3}[\s.\-]?\d{4}( [xX]\d+)?$/;
  const re = opts?.withExt ? phoneWithExtRe : phoneRe;
  const error = `This field must be a valid phone number format${opts?.withExt ? ' (with an optional extension)' : ''}.`;
  return !value || re.test(value) || error;
};

const rulesFromFieldConfig = (field: FieldConfig) => {
  const rules: FormRule[] = [];
  if (field.required) {
    rules.push(required());
  }
  if (field.maxLength) {
    rules.push(maxLength(field.maxLength));
  }
  if (field.type === 'email') {
    rules.push(email());
  }
  else if (field.type === 'phone') {
    rules.push(phone());
  }
  else if (field.type === 'phoneWithExt') {
    rules.push(phone({ withExt: true }));
  }
  return rules;
};

export default () => ({
  rulesFromFieldConfig,
  required,
  maxLength,
  email,
  phone,
});
